(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  document.addEventListener(
    'click',
    (event) => {
      if (!mobileQuery.matches) return;

      const poster = event.target.closest(
        '.product-media-modal .deferred-media__poster'
      );
      if (!poster) return;

      const deferredMedia = poster.closest('deferred-media');
      const mediaTemplate = deferredMedia?.querySelector('template');
      const youtubeIframe = mediaTemplate?.content.querySelector(
        'iframe.js-youtube'
      );
      if (!deferredMedia || !youtubeIframe) return;

      try {
        const youtubeUrl = new URL(youtubeIframe.src);
        youtubeUrl.searchParams.set('playsinline', '0');
        youtubeIframe.src = youtubeUrl.toString();
        youtubeIframe.setAttribute('allowfullscreen', '');
      } catch (error) {
        // Keep normal YouTube playback if its URL can't be adjusted.
      }

      const requestFullscreen =
        deferredMedia.requestFullscreen ||
        deferredMedia.webkitRequestFullscreen;

      if (requestFullscreen) {
        const fullscreenResult = requestFullscreen.call(deferredMedia);
        fullscreenResult?.catch?.(() => {
          // iOS uses playsinline=0 as the native fullscreen fallback.
        });
      }
    },
    true
  );
})();
